import { useState } from "react";
import PermissionSwitchboard from "./PermissionSwitchboard";

export default function CreateAdminModal({ allPermissions, onClose, onCreate }) {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [permissions, setPermissions] = useState([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }
    setBusy(true);
    try {
      await onCreate({ ...form, permissions });
    } catch (err) {
      setError(err.response?.data?.message || "Could not create admin");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h2 style={styles.title}>New Sub Admin</h2>
        <p style={styles.subtitle}>Choose exactly which features this admin can access.</p>

        <form onSubmit={submit} style={styles.form}>
          <div style={styles.fieldsRow}>
            <label style={styles.label}>
              Full name
              <input
                style={styles.input}
                required
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
              />
            </label>
            <label style={styles.label}>
              Email
              <input
                type="email"
                style={styles.input}
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </label>
            <label style={styles.label}>
              Temporary password
              <input
                type="password"
                style={styles.input}
                required
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
              />
            </label>
          </div>

          <div>
            <div style={styles.sectionLabel}>Permissions</div>
            <PermissionSwitchboard
              allPermissions={allPermissions}
              selected={permissions}
              onChange={setPermissions}
            />
          </div>

          {error && <div style={styles.error}>{error}</div>}

          <div style={styles.actions}>
            <button type="button" style={styles.cancel} onClick={onClose}>
              Cancel
            </button>
            <button type="submit" style={styles.submit} disabled={busy}>
              {busy ? "Creating…" : "Create admin"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(20,24,31,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 50,
  },
  modal: {
    background: "#fff",
    width: 520,
    maxWidth: "92vw",
    maxHeight: "88vh",
    overflowY: "auto",
    borderRadius: "var(--radius)",
    padding: 28,
  },
  title: { fontFamily: "var(--font-display)", fontSize: 22, margin: 0 },
  subtitle: { color: "var(--slate-500)", fontSize: 13, marginTop: 4, marginBottom: 20 },
  form: { display: "flex", flexDirection: "column", gap: 20 },
  fieldsRow: { display: "flex", flexDirection: "column", gap: 12 },
  label: { display: "flex", flexDirection: "column", gap: 6, fontSize: 13, color: "var(--slate-500)" },
  input: {
    border: "1px solid var(--line)",
    borderRadius: 4,
    padding: "9px 10px",
    fontSize: 14,
  },
  sectionLabel: { fontSize: 13, fontWeight: 600, marginBottom: 8 },
  error: {
    background: "rgba(217,99,78,0.1)",
    border: "1px solid var(--danger)",
    color: "#a8402c",
    fontSize: 13,
    padding: "8px 10px",
    borderRadius: 4,
  },
  actions: { display: "flex", justifyContent: "flex-end", gap: 10 },
  cancel: {
    background: "transparent",
    border: "1px solid var(--line)",
    borderRadius: 4,
    padding: "9px 16px",
    fontSize: 13,
  },
  submit: {
    background: "var(--signal)",
    border: "none",
    borderRadius: 4,
    padding: "9px 18px",
    fontSize: 13,
    fontWeight: 600,
  },
};
